const offlineName = 'Offline';
class OfflineError extends Error {
    constructor() {
        super(offlineName);
        this.name = this.message;
    }
}
export { OfflineError };
